import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppCore } from 'src/app/utils/classes/app-core';

@Component({
  selector: 'app-select-game-type',
  templateUrl: './select-game-type.component.html',
  styleUrls: ['./select-game-type.component.scss']
})
export class SelectGameTypeComponent extends AppCore implements OnInit {

  @Output() DataArray = new EventEmitter();
  @Output() DataString = new EventEmitter();

  GameTypeSelect: string[] = [];

  constructor() {
    super();
  }

  ngOnInit() {
    this.outputGameType();
  }

  onSelectGameType(gameType: string) {
    if (!this.GameTypeSelect.includes(gameType)) {
      this.GameTypeSelect.push(gameType);
      this.outputGameType();
    } else if (this.GameTypeSelect.length === this.constDataPreload?.game?.game_type?.length) {
      this.GameTypeSelect = [];
      this.GameTypeSelect.push(gameType);
      this.outputGameType();
    } else {
      this.GameTypeSelect.splice(this.GameTypeSelect.findIndex(x => x == gameType), 1);
      this.outputGameType();
    }
  }

  outputGameType() {
    this.DataArray.next(this.GameTypeSelect);
    this.DataString.next(this.GameTypeSelect.join(','));
  }

}
